import { useEffect } from 'react'

import styles from './styles/PublishersPanel.css'
import TalkToUs from './TalkToUs'
import PartnerValueProp from './PartnerValueProp'
import PartnersPanel from './PartnersPanel'
import P from 'components/typography/Paragraph'
import AwardsAndPress from './Awards'
import * as analytics from 'lib/analytics'
import Button from '../forms/Button'
import classNames from 'classnames'
import { useHistory } from 'react-router'
import Card from '../layout/Card'
import Header from '../typography/Header'

const PublishersPanel = () => {
  const history = useHistory()
  useEffect(() => {
    analytics.event({
      category: 'Partners',
      action: 'View Publishers Partners Page'
    })
  }, [])

  return (
    <div className={styles.layout}>
      <TalkToUs
        header={false}
        cta={
          <Button className={classNames(styles.submitBtn, styles.transparentBtn)} onClick={() => history.push('/pricing?tab=organizations')} color='transparent'>Get started with integration</Button>
        }
        subheader='Get in touch with our team to learn more about how scite can help drive thousands of users to your publications a week'
      />
      <PartnerValueProp
        className={styles.valueProp}
        id='make-content-discoverable'
        illo={`${CONFIG.assetsBaseURL}/images/icons/institution-spyglass.svg`}
        header='Make your content discoverable'
        link='View Indexing Agreement'
        linkLocation={`${CONFIG.assetsBaseURL}/documents/indexing-agreement-sample.pdf`}
      >
        <P>
          Improve the discoverability of your articles and raise the profile of your publications by indexing them with scite. scite reports attract thousands of users a week and generate significant traffic for publisher partners.
        </P>
        <Header level={6} center>
          Some of our stats and figures on fulltext click throughs:
        </Header>
        <ul className={styles.stats}>
          <li>Average monthly fulltext clicks per user is: 7</li>
          <li>Average monthly fulltext clicks per report is: 5</li>
        </ul>

      </PartnerValueProp>
      <PartnerValueProp
        className={styles.valueProp}
        id='demonstrate-how-reliable'
        header='Demonstrate how reliable your publications are'
        cta='Embed Badges'
        ctaLocation='/badge'
      >
        <P>
          Instead of showing just how many times a publication has been cited, show explicitly which articles have been supported by displaying the Smart Citation badge on your articles. Badges create a link to scite reports for readers to understand the full citation contexts of the article they are reading. Building trust with readers is important, scite can help.
        </P>
        <img alt='page badge' src={`${CONFIG.assetsBaseURL}/images/illustrations/page-badge-illo.png?v=1`} />
      </PartnerValueProp>
      <PartnerValueProp
        className={styles.valueProp}
        id='author-marketing'
        header='Attract new submissions and re-engage authors'
        cta='Find out more'
        ctaLocation='/author-marketing'
      >
        <P>
          Send author marketing campaigns based on scite data to show them how their work has been supported, contrasted, or mentioned by others and how you can help improve quality and visibility of their work.
        </P>
        <Card level={1}>
          <img alt='example email' className={styles.emailImage} src={`${CONFIG.assetsBaseURL}/images/illustrations/email-alert.png`} />
        </Card>
        <br />
      </PartnerValueProp>
      <PartnerValueProp
        className={styles.valueProp}
        id='make-content-discoverable'
        illo={`${CONFIG.assetsBaseURL}/images/icons/people-talking.svg`}
        header='Help support your authors and enhance the quality of your submissions'
        cta='See example reference check'
        ctaLocation='/reference-check/7ddc4c40-2833-41ea-bf3e-40fe119b388b'
        link='Understand how it works'
        linkLocation='https://www.youtube.com/watch?v=O8QGslOeQXU'
      >
        <P>
          Stop worrying about the quality of your submissions by integrating scite Reference Check into your submission process. scite Reference Check helps authors and editors understand the quality of their references and surfaces heavilty disputed, out-of-date, and retracted references.
        </P>
        <img alt='reference-check' src={`${CONFIG.assetsBaseURL}/images/illustrations/reference-check.png`} />
      </PartnerValueProp>
      <PartnerValueProp
        className={styles.valueProp}
        id='understand-your-journals'
        header='Understand your journals and track how articles are cited over time'
        cta='View Journals'
        ctaLocation='/journals'
      >
        <P>
          Use scite Journal dashboards to better understand how articles in your journal(s) have been cited. Discover how many supporting or contrasting citations your journal has received and what is the most supported or contrasted article in your journal.
        </P>
        <P>
          Track individual publications or set an email alert to track citations to your entire journal. scite provides a view of your publications like no other.
        </P>
        <img alt='journal index' className={styles.journalIndex} src={`${CONFIG.assetsBaseURL}/images/illustrations/journal-index-2.png?v=1`} />
      </PartnerValueProp>
      <PartnersPanel header='Who we’re working with' />
      <AwardsAndPress />
      <TalkToUs
        pricingTab='organizations'
      />
    </div>
  )
}

export default PublishersPanel
